import styled from "styled-components";
import BackgroundGrid from "../../assets/bg-grid.svg";
import CloseX from "../../components/CloseX";
import { useState } from "react";
import MagnifierBtn from "../../assets/magnifier-btn.png";

const AlbumWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background-image: url(${BackgroundGrid});
  background-color: #72969b;

  position: fixed; // ✅ instead of absolute
  top: 0;
  left: 0;
  z-index: 9999;   // ✅ high z-index to appear on top

  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
`;


const Album = styled.div`
  margin-top: 50px;
`;

const DisplayedImage = styled.img`
  height: 68vh;
  width: 100%;
  max-width: 100%;
  object-fit: cover;
  
`;

const AlbumContent = styled.div`
  padding: 0 93px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
`;


const Thumbnails = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  
  flex-wrap: nowrap; // no wrap
  
`;




const ThumbWrapper = styled.div`
  position: relative;
  width: 94px;
  height: 94px;
  flex: 0 0 auto;

  &:after {
    content: "";
    background-color: black;
    opacity: 0.5;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
   
  }
`;





const ThumbImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
`;


const MagnifierImg = styled.img`
  position: absolute;
  z-index: 10;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  cursor: pointer;
`;

export const CastleAlbum = ({ images, handleClose, open }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <AlbumWrapper>
      {" "}
      <CloseX handleClick={handleClose} open={open} />
      <Album>
  <AlbumContent>
    <DisplayedImage src={images[activeIndex]} />
    <Thumbnails>
  {images.map((image, index) => (
    <ThumbWrapper key={image} count={images.length}>
      <MagnifierImg
        src={MagnifierBtn}
        onClick={() => setActiveIndex(index)}
      />
      <ThumbImage src={image} />
    </ThumbWrapper>
  ))}
</Thumbnails>

  </AlbumContent>
</Album>

    </AlbumWrapper>
  );
};
